import React from 'react';
import { Switch } from 'react-router-dom';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';
import ProfileEdit from './routes/ProfileEdit';
import Profile from './routes/Profile';
import ProfileFollowList from './routes/ProfileFollowList';
import Credits from './routes/Credits';
import Subscription from './routes/Subscription';

const Account = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}/credits`} component={Credits} />
      <Route path={`${match.path}/subscription`} component={Subscription} />
      <Route path={`${match.path}/edit`} component={ProfileEdit} />
      <Route path={`${match.path}/list/:state?`} component={ProfileFollowList} />
      <Route path={`${match.path}/`} component={Profile} />
    </Switch>
  );
};

export default Account;
